(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-faq"] && !Shopify.designMode) return;
  try {
    $(document).ready(function(){
  $(".accordian-question").click(function(){
    let parent = $(this).parent();

    if(parent.hasClass("active")){
      parent.removeClass("active");
      parent.find(".accordian-answer").slideUp(400);

    } else {
      $(".accordian-item").removeClass("active");
      $(".accordian-answer").slideUp(400);

      parent.addClass("active");
      parent.find(".accordian-answer").slideDown(400);
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
